const cloneScript = (script: Element) => {
  const s = document.createElement("script");

  const attrs = script.attributes;
  for (let i = 0; i < attrs.length; i++) {
    s.setAttribute(attrs[i].name, attrs[i].value);
  }

  s.text = script.innerHTML;

  return s;
};

export const addCustomScripts = (custom_tag: string): Promise<unknown>[] => {
  const loaders: Promise<unknown>[] = [];

  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(custom_tag, "text/html");
    const collection = doc.head.children;

    Array.from(collection)
      .map((script) => cloneScript(script))
      .forEach((script) => {
        let resolver: (v: any) => any = () => {
          console.log("It's a dummy fn to avoid error!");
        };

        const promise = new Promise((resolve) => {
          resolver = resolve;
        });

        if (resolver) {
          script.addEventListener("load", resolver);

          if (script.src.length > 0) {
            loaders.push(promise);
          } else {
            resolver(undefined);
          }
        }
        document.body.appendChild(script);
      });
  } catch (e) {
    console.error(e);
  }

  return loaders;
};
